<template lang="pug">
  main
    NavBar
    Loader(v-show="isLoading")
    section.section(v-show="!isLoading")
      .container
        .columns
          .column.has-text-centered
            h1.title Nuevo Movimiento de Tags&nbsp
              |
              a.button.is-black.is-rounded(@click="backToPage")
                i.fas.fa-times
        .columns
          .column.is-12
            FormNuevoMovimientoTag(:tags="tags" :cruces="cruces" @saveForm="saveForm")
        .columns(v-show="tags.length < 1")
          .column.is-offset-4.is-4
            .notificacion.is-light
              strong No hay tags asignadas para éste usuario.
        .columns.column-blanco
</template>

<script>
  import NavBar from './layout/NavBarTransportes.vue'
  import FormNuevoMovimientoTag from './componentes/FormNuevoMovimientoTag.vue'
  import Loader from '@/components/shared/Loader.vue'
  import InventarioServices from '@/services/inventario/inventario'
  
  export default {
    name: 'NewMovimientoTarjeta',
    components: { NavBar, Loader, FormNuevoMovimientoTag },
    data() {
      return {
        isLoading: true,
        tags: [],
        tagSel: {},
        cruces: [],
        cruceSel: {},
        verNotificacionTarjeta: false
      }
    },
    methods: {
      iniciarComponente() {
        this.obtenerTags()
      },
      
      obtenerTags() {
        InventarioServices.getTags_All()
          .then((data) => {
            this.tags = data.map(this.convertirTags)
            this.obtenerCruces()
          })
          .catch((e) => {
            this.isLoading = false
            this.displayToast('bubble',`Error: ${e.message}`,'ban','OK')
          })
      },
      convertirTags (t) {
        return {
          ...t,
          id: parseInt(t.id)
        }
      },

      obtenerCruces () {
        InventarioServices.getTags_Cruces()
          .then((data) => {
            this.cruces = data.map(this.convetirCruces)
            this.isLoading = false
          })
          .catch((e) => {
            this.isLoading = false
            this.displayToast('bubble',`Error: ${e.message}`,'ban','OK')
          })
      },

      convetirCruces (c) {
        return {
          ...c,
          id: parseInt(c.id)
        }
      },

      saveForm(f) {
        InventarioServices.addTag_Movimiento (f.tag.id, f.fecha, f.periodo, f.cargo, f.abono, f.transaccion, f.clase, f.cruce.id)
          .then( data => {
            this.displayToast(data.success ? 'toasted-primary' : 'bubble', data.respuesta, data.success ? 'done' : 'ban', 'OK')
            this.isLoading = false
            this.$router.push('/Transportes/Tags/Movimientos')
          })
          .catch( e => {
            this.isLoading = false
            this.displayToast('bubble',`Error: ${e.message}`,'ban','OK')
          })
      },

      displayToast(tema,text, icon, actionText) {
        let toast = this.$toasted.show(text, { 
          theme: tema, 
          position: "bottom-right", 
          duration : 3000,
          iconPack: 'fontawesome',
          icon: icon,
          action : {
            text : actionText,
            onClick : (e, toastObject) => {
              toastObject.goAway(0)
            }
          },
        })
      },

      backToPage () {
        this.$router.back()
      },
    },
    created () {
      this.iniciarComponente()
    },
  }
</script>

<style lang="scss" scoped>
  .column-blanco {
    padding-bottom: 100px;
  }
</style>


// WEBPACK FOOTER //
// src/components/combustibles_Componentes/NewMovimientoTag.vue